import React, { useState } from 'react';
import './SampleScreenshots.css';

const SampleScreenshots = () => {
    const [activeTab, setActiveTab] = useState('amazon'); // 'amazon', 'flipkart', 'nykaa', 'myntra'
    const [selectedImage, setSelectedImage] = useState(null); // State for the popup image

    // Map platforms to their respective sample images
    // Note: Images should be placed in public/assets/images/
    // Naming convention: {platform}_{type}_sample.jpg
    const sampleImages = {
        amazon: {
            order: '/assets/images/amazon_delivered.webp',
            rating: '/assets/images/amazon_rating.png',
            review: '/assets/images/amazon_reviewSubmit.webp',
            liveReview: '/assets/images/amazon_liveReview.png'
        },
        flipkart: {
            order: '/assets/images/Flipkart Order SS.webp',
            rating: '/assets/images/Flipkart Delivered With Return Window Closed Sample.webp',
            review: '/assets/images/Flipkart Review Screenshot Sample.webp'
        },
        nykaa: {
            order: '/assets/images/Nykaa Order Screenshot.webp',
            rating: '/assets/images/Nykaa Delivered Screenshot.webp',
            review: '/assets/images/Nykaa Review Screenshot.webp'
        },
        myntra: {
            order: '/assets/images/Nykaa Order Screenshot.webp',
            rating: '/assets/images/Nykaa Delivered Screenshot.webp',
            review: '/assets/images/Nykaa Review Screenshot.webp'
        }
    };

    const renderImage = (src, altText) => {
        return (
            <div className="image-container" onClick={() => setSelectedImage(src)}>
                <img
                    src={src}
                    alt={altText}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none'; // Hide broken image
                        e.target.nextSibling.style.display = 'flex'; // Show placeholder
                        e.target.parentElement.onclick = null; // Disable click if no image
                    }}
                />
                <div className="placeholder-fallback" style={{ display: 'none' }}>
                    <span>{altText} (Image not found)</span>
                </div>
                <div className="hover-overlay">
                    <i className="ri-zoom-in-line"></i> Click to Expand
                </div>
            </div>
        );
    };

    const currentImages = sampleImages[activeTab];

    const renderSampleImages = () => {
        return (
            <div className="sample-grid">
                <div className="sample-item">
                    <h4>Order Screenshot</h4>
                    {renderImage(currentImages.order, `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Order SS`)}
                </div>
                <div className="sample-item">
                    <h4>Rating Screenshot</h4>
                    {renderImage(currentImages.rating, `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Rating SS`)}
                </div>
                <div className="sample-item">
                    <h4>Review Submission Screenshot</h4>
                    {renderImage(currentImages.review, `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Review Submission SS`)}
                </div>
                {/* Optional Live Review Screenshot */}
                {currentImages.liveReview && (
                    <div className="sample-item">
                        <h4>Live Review Screenshot</h4>
                        {renderImage(currentImages.liveReview, `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Live Review SS`)}
                    </div>
                )}
            </div>
        );
    };

    const renderTutorials = () => {
        return (
            <div className="tutorials-section">
                <div className="tutorials-header">
                    <h3><i className="ri-youtube-line"></i> Video Tutorials</h3>
                    <p>Watch these videos to understand the process.</p>
                    <a href="https://www.youtube.com/@collaborationworld" target="_blank" rel="noopener noreferrer" className="channel-link-btn">
                        <i className="ri-youtube-fill"></i> Visit Our Channel
                    </a>
                </div>
            </div>
        );
    };

    return (
        <div className="sample-ss-container">
            <div className="sample-ss-header">
                <h2><i className="ri-book-open-line"></i> Samples and Tutorials</h2>
                <p>Learn how to complete tasks with step-by-step guides and reference screenshots.</p>
            </div>

            <div className="sample-section-header">
                <h3><i className="ri-image-line"></i> Sample Screenshots</h3>
                <p>Reference screenshots for different platforms.</p>
            </div>

            <div className="platform-tabs">
                {Object.keys(sampleImages).map(platform => (
                    <button
                        key={platform}
                        className={`platform-tab ${activeTab === platform ? 'active' : ''}`}
                        onClick={() => setActiveTab(platform)}
                    >
                        {platform.charAt(0).toUpperCase() + platform.slice(1)}
                    </button>
                ))}
            </div>

            {renderSampleImages()}

            {renderTutorials()}

            {/* Image Preview Modal */}
            {selectedImage && (
                <div className="image-modal-overlay" onClick={() => setSelectedImage(null)}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal-btn" onClick={() => setSelectedImage(null)}>
                            <i className="ri-close-line"></i>
                        </button>
                        <img src={selectedImage} alt="Preview" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SampleScreenshots;
